<script>
import BaseModalRamadan from './BaseModalRamadan.vue'

export default {
  name: 'RamadanModal',
  components: {
    BaseModalRamadan
  },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    closeModal () {
      this.$emit('update:show', false)
    }
  },
  computed: {
    locale () {
      return this.$i18n.locale
    },
    isRtl () {
      return this.locale === 'ar'
    }
  },
  watch: {
    show (value) {
      const body = document.querySelector('body')
      if (value) {
        body.classList.add('overflow-off')
      } else {
        body.classList.remove('overflow-off')
      }
    }
  },
  destroyed () {
    const body = document.querySelector('body')
    body.classList.remove('overflow-off')
  }
}
</script>

<template>
  <keep-alive>
    <BaseModalRamadan
      class-name="ramadan-popup"
      :popupBig="true"
      @close="closeModal"
      :visible="show"
    >
      <div :class="{rtl: isRtl}">
        <div class="ramadan-modal">
          <div class="ramadan-modal__close-button">
            <button @click="closeModal" aria-label="close modal">
              <img src="./assets/x.svg" alt="close icon"/>
            </button>
          </div>
          <div class="ramadan-modal__texts">
            <p class="ramadan-modal__title">
              <bdi>{{ $t('ramadan.popup.header') }}</bdi>
            </p>
            <p class="ramadan-modal__subtitle">
              {{ $t('ramadan.banner.car.title') }}
              <img src="./assets/ticket.svg" alt="ticket"/>
              {{ $t('ramadan.banner.end.title') }}
            </p>
          </div>

          <div class="ramadan-modal__body">
            <img v-if="!isRtl" src="./assets/body-gifts-en.png" alt="gift"/>
            <img v-if="isRtl" src="./assets/body-gifts-ar.png" alt="gift"/>
          </div>
        </div>
      </div>
    </BaseModalRamadan>
  </keep-alive>
</template>

<style lang="scss">
.ramadan-popup {
  background: linear-gradient(326deg, #c8c9fc -31.73%, #6568f4 111.28%);
  font-family: 'PP Neue Montreal', sans-serif;
  color: white;
  max-width: 544px;
  padding: 0;
  overflow: hidden;
}

.ramadan-modal__close-button {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: relative;
}

.ramadan-modal__close-button button {
  border: none;
  cursor: pointer;
  background: none;
  width: 24px;
  height: 24px;
  z-index: 2;
}

.ramadan-modal {
  background-image: url('./assets/background-pattern-dark.svg');
  position: relative;
  overflow: hidden;
  padding: 40px;
  max-width: inherit;
  background-repeat: no-repeat;
  background-size: 75%;
  background-position-x: calc(100% + 25px);
  background-position-y: 90%;
}

.ramadan-modal__background {
  position: absolute;
  width: 430px;
  bottom: -3%;
  right: -4%;
}

.ramadan-modal__texts {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  max-width: 420px;
  margin-inline: auto;
  margin-block-end: 33px;
}

.ramadan-modal__title {
  text-align: center;
  font-size: 48px;
  font-style: normal;
  font-weight: 600;
  line-height: 56px;
}

.ramadan-modal__subtitle {
  font-size: 18px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
  max-width: 410px;
  text-align: center;
}

.ramadan-modal__subtitle img {
  margin: 0 2px;
  height: 18px;
  width: 27px;
  vertical-align: middle;
}

.ramadan-modal__quantity {
  display: flex;
  padding: 5px 10px;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 20.25px;
  color: #231844;
  z-index: -1;
}

.ramadan-modal__body {
  position: relative;
  z-index: 2;
  background-size: cover;
}

.ramadan-modal__body img {
  width: 100%;
}

@media (max-width: 550px) {
  .ramadan-popup {
    max-width: initial;
  }

  .ramadan-modal__background {
    max-width: 345px;
    right: -17%;
    bottom: initial;
    top: 50%;
  }

  .ramadan-modal {
    padding: 16px;
    width: 100%;
  }

  .ramadan-modal__texts {
    max-width: 315px;
  }

  .ramadan-modal__title {
    font-size: 36px;
    line-height: 44px;
  }

  .ramadan-modal__subtitle {
    font-size: 14px;
    line-height: 24px;
  }

  .ramadan-modal__body {
    width: 100%;
    height: initial;
  }
}

.rtl {
  .ramadan-modal {
    background-size: 80%;
    background-position-x: -25px;
  }
  .ramadan-modal__body {
    margin-block-end: 20px;
  }

  .ramadan-modal__close-button {
    justify-content: flex-start;
  }
}
</style>
